import { size } from "polished"
import styled from "styled-components"

export const Positioner = styled.div`
  ${size(16)}

  position: relative;
`
